import React from 'react';
import { GERAR_CSV_GET } from '../../Api';
import useFetch from '../../Hooks/useFetch';
import useForm from '../../Hooks/useForm';
import Button from '../Forms/Button';
import Select from '../Forms/Select';
import Head from '../Helper/Head';
import SistemaIndisponivel from '../SistemaIndisponivel';
import styles from './Requests.module.css';
import Loading from '../Helper/Loading';
import MUIDataTable from 'mui-datatables';

const GerarCsv = () => {
  const month = useForm();
  const year = useForm();
  const userType = useForm();
  const cadastroSocial = useForm();
  const [results, setResults] = React.useState('');
  const [status, setStatus] = React.useState('');
  var totalCpf = 0;
  var totalCpfConvertido;
  var totalCads = 0;

  const { loading, request } = useFetch();

  async function handleSubmit(event) {
    event.preventDefault();

    if (
      month.validate() &&
      year.validate() &&
      userType.validate() &&
      cadastroSocial.validate()
    ) {
      let startDate = '';
      let endDate = '';

      switch (month.value) {
        case '01':
          startDate = `01${month.value}${year.value}000000`;
          endDate = `31${month.value}${year.value}235900`;
          break;
        case '02':
          // Tratando Fevereiro, pois pode ter 28 ou 29 dias
          if (
            +year.value % 4 === 0 &&
            (+year.value % 100 !== 0 || +year.value % 400 === 0)
          ) {
            startDate = `01${month.value}${year.value}000000`;
            endDate = `29${month.value}${year.value}235900`;
          } else {
            startDate = `01${month.value}${year.value}000000`;
            endDate = `28${month.value}${year.value}235900`;
          }
          break;
        case '03':
          startDate = `01${month.value}${year.value}000000`;
          endDate = `31${month.value}${year.value}235900`;
          break;
        case '04':
          startDate = `01${month.value}${year.value}000000`;
          endDate = `30${month.value}${year.value}235900`;
          break;
        case '05':
          startDate = `01${month.value}${year.value}000000`;
          endDate = `31${month.value}${year.value}235900`;
          break;
        case '06':
          startDate = `01${month.value}${year.value}000000`;
          endDate = `30${month.value}${year.value}235900`;
          break;
        case '07':
          startDate = `01${month.value}${year.value}000000`;
          endDate = `31${month.value}${year.value}235900`;
          break;
        case '08':
          startDate = `01${month.value}${year.value}000000`;
          endDate = `31${month.value}${year.value}235900`;
          break;
        case '09':
          startDate = `01${month.value}${year.value}000000`;
          endDate = `30${month.value}${year.value}235900`;
          break;
        case '10':
          startDate = `01${month.value}${year.value}000000`;
          endDate = `31${month.value}${year.value}235900`;
          break;
        case '11':
          startDate = `01${month.value}${year.value}000000`;
          endDate = `30${month.value}${year.value}235900`;
          break;
        case '12':
          startDate = `01${month.value}${year.value}000000`;
          endDate = `31${month.value}${year.value}235900`;
          break;
        default:
          console.log('Aconteceu algo errado com o preenchimento do mês');
      }

      const body = {
        startDate: startDate,
        endDate: endDate,
        userType: userType.value,
        isCNPJ: cadastroSocial.value === '3' ? true : false,
      };

      const { url, options } = GERAR_CSV_GET(body);
      const { response, json } = await request(url, options);

      setResults(json.UsersTransactions);

      if (response === undefined || json.UsersTransactions === undefined) {
        setStatus(undefined);
        alert(`Erro: Tente novamente mais tarde.`);
      }

      if (response !== undefined) {
        if (json === null) return null;

        if (response.ok === false) {
          alert(`Erro: Tente novamente mais tarde.`);
        }
      }
    }
  }

  function createData(
    cpf_cnpj,
    nome,
    telefone,
    endereco,
    numero,
    bairro,
    cep,
    uf,
    cads,
    valorMargem,
    valor,
    margem,
  ) {
    return {
      cpf_cnpj,
      nome,
      telefone,
      endereco,
      numero,
      bairro,
      cep,
      uf,
      cads,
      valorMargem,
      valor,
      margem,
    };
  }

  function formataCpfCnpj(cpf_cnpj) {
    //retira os caracteres indesejados...
    cpf_cnpj = cpf_cnpj.replace(/[^\d]/g, '');

    //realizar a formatação...
    if (cpf_cnpj.length === 11) {
      return cpf_cnpj.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    }
    if (cpf_cnpj.length === 14) {
      return cpf_cnpj.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        '$1.$2.$3/$4-$5',
      );
    }
  }

  function formataZipCode(zipCode) {
    //retira os caracteres indesejados...
    zipCode = zipCode?.replace(/[^\d]/g, '');

    //realizar a formatação...
    return zipCode?.replace(/(\d{5})(\d{3})/, '$1-$2');
  }

  const data = [];
  for (var i = 0; i < results.length; i++) {
    totalCads = totalCads + results[i].cads;

    if (cadastroSocial.value === '1') {
      let cpf_cnpj = formataCpfCnpj(results[i].cpf_cnpj);
      let cep = formataZipCode(results[i].cep);
      const value = results[i].valor.replace('.', ',');
      const valorBruto = `R$ ${value}`;
      const valueNf = results[i].margem.replace('.', ',');
      const valorNf = `R$ ${valueNf}`;
      const valorMargem = results[i].margem / results[i].cads;

      if (cpf_cnpj.length === 14) {
        totalCpf = totalCpf + +results[i].margem;
        totalCpfConvertido = totalCpf.toFixed(2).replace('.', ',');
      }

      data.push(
        createData(
          cpf_cnpj,
          results[i].nome,
          results[i].telefone,
          results[i].endereco,
          results[i].numero,
          results[i].bairro,
          cep,
          results[i].uf,
          results[i].cads,
          valorMargem.toFixed(2).replace('.', ','),
          valorBruto,
          valorNf,
        ),
      );
    }

    if (cadastroSocial.value === '2' && results[i].cpf_cnpj.length === 11) {
      let cpf_cnpj = formataCpfCnpj(results[i].cpf_cnpj);
      let cep = formataZipCode(results[i].cep);
      const value = results[i].valor.replace('.', ',');
      const valorBruto = `R$ ${value}`;
      const valueNf = results[i].margem.replace('.', ',');
      const valorNf = `R$ ${valueNf}`;
      const valorMargem = results[i].margem / results[i].cads;

      if (cpf_cnpj.length === 14) {
        totalCpf = totalCpf + +results[i].margem;
        totalCpfConvertido = totalCpf.toFixed(2).replace('.', ',');
      }

      data.push(
        createData(
          cpf_cnpj,
          results[i].nome,
          results[i].telefone,
          results[i].endereco,
          results[i].numero,
          results[i].bairro,
          cep,
          results[i].uf,
          results[i].cads,
          valorMargem.toFixed(2).replace('.', ','),
          valorBruto,
          valorNf,
        ),
      );
    }

    if (cadastroSocial.value === '3' && results[i].cpf_cnpj.length === 14) {
      let cpf_cnpj = formataCpfCnpj(results[i].cpf_cnpj);
      let cep = formataZipCode(results[i].cep);
      const value = results[i].valor.replace('.', ',');
      const valorBruto = `R$ ${value}`;
      const valueNf = results[i].margem.replace('.', ',');
      const valorNf = `R$ ${valueNf}`;
      const valorMargem = results[i].margem / results[i].cads;

      if (cpf_cnpj.length === 14) {
        totalCpf = totalCpf + +results[i].margem;
        totalCpfConvertido = totalCpf.toFixed(2).replace('.', ',');
      }

      data.push(
        createData(
          cpf_cnpj,
          results[i].nome,
          results[i].telefone,
          results[i].endereco,
          results[i].numero,
          results[i].bairro,
          cep,
          results[i].uf,
          results[i].cads,
          valorMargem.toFixed(2).replace('.', ','),
          valorBruto,
          valorNf,
        ),
      );
    }
  }

  const columns = [
    {
      name: 'cpf_cnpj',
      label: 'CPF ou CNPJ',
      options: {
        filter: true,
        sort: true,
        sortCompare:
          (order) =>
          ({ data: cpfCnpj1 }, { data: cpfCnpj2 }) =>
            (cpfCnpj1.length - cpfCnpj2.length) * (order === 'asc' ? 1 : -1),
      },
    },
    {
      name: 'nome',
      label: 'NOME',
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: 'telefone',
      label: 'TELEFONE',
      options: {
        filter: true,
        sort: false,
        display: false,
      },
    },
    {
      name: 'endereco',
      label: 'ENDEREÇO',
      options: {
        filter: true,
        sort: false,
        display: false,
      },
    },
    {
      name: 'numero',
      label: 'NÚMERO',
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: 'bairro',
      label: 'BAIRRO',
      options: {
        filter: true,
        sort: false,
        display: false,
      },
    },
    {
      name: 'cep',
      label: 'CEP',
      options: {
        filter: true,
        sort: false,
        display: false,
      },
    },
    {
      name: 'uf',
      label: 'UF',
      options: {
        filter: true,
        sort: true,
        display: false,
      },
    },
    {
      name: 'cads',
      label: 'CADS',
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: 'valorMargem',
      label: 'VALOR MARGEM',
      options: {
        filter: true,
        sort: true,
        sortCompare: (order) => {
          return (obj1, obj2) => {
            let val1 = parseInt(obj1.data.replace('R$ ', ''), 10);
            let val2 = parseInt(obj2.data.replace('R$ ', ''), 10);
            return (val1 - val2) * (order === 'asc' ? 1 : -1);
          };
        },
      },
    },
    {
      name: 'valor',
      label: 'VALOR BRUTO',
      options: {
        filter: true,
        sort: true,
        sortCompare: (order) => {
          return (obj1, obj2) => {
            let val1 = parseInt(obj1.data.replace('R$ ', ''), 10);
            let val2 = parseInt(obj2.data.replace('R$ ', ''), 10);
            return (val1 - val2) * (order === 'asc' ? 1 : -1);
          };
        },
      },
    },
    {
      name: 'margem',
      label: 'VALOR NF',
      options: {
        filter: true,
        sort: true,
        sortCompare: (order) => {
          return (obj1, obj2) => {
            let val1 = parseInt(obj1.data.replace('R$ ', ''), 10);
            let val2 = parseInt(obj2.data.replace('R$ ', ''), 10);
            return (val1 - val2) * (order === 'asc' ? 1 : -1);
          };
        },
      },
    },
  ];

  const options = {
    responsive: 'simple',
    draggableColumns: {
      enabled: true,
    },
    selectableRows: 'none',
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: 'false',
    download: 'true',
    onDownload: (buildHead, buildBody, columns, data) => {
      return '\uFEFF' + buildHead(columns) + buildBody(data);
    },
    downloadOptions: {
      filename: userType.value === '1' ? 'Vendas APP.csv' : 'Vendas PDV.csv',
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
    },
    textLabels: {
      body: {
        noMatch: 'Desculpe, nenhum registro foi encontrado',
        toolTip: 'Ordenar',
        columnHeaderTooltip: (column) => `Ordenar por ${column.label}`,
      },
      pagination: {
        next: 'Próxima Página',
        previous: 'Página Anterior',
        rowsPerPage: 'Linhas por página:',
        displayRows: 'of', // 1-10 of 30
      },
      toolbar: {
        search: 'Pesquisar',
        viewColumns: 'Selecionar Colunas',
        filterTable: 'Filtrar Tabela',
      },
      filter: {
        title: 'FILTROS',
        reset: 'limpar',
        all: 'Todos',
      },
      viewColumns: {
        title: 'Mostrar Colunas',
        titleAria: 'Mostrar/Esconder Colunas da Tabela',
      },
    },
    customToolbarSelect: () => {},
  };

  if (status === undefined) {
    return <SistemaIndisponivel />;
  }
  if (loading) return <Loading />;
  if (results === '') {
    return (
      <section className="container animeLeft">
        <Head title="Gerar CSV para Notas Fiscais" />
        <h1 className="title">Gerar CSV para Notas Fiscais</h1>
        <form onSubmit={handleSubmit}>
          <div className={styles.flex}>
            <Select
              className={styles.select}
              label="Mês"
              name="month"
              required
              {...month}
            >
              <option value="">Selecione</option>
              <option value="01">Janeiro</option>
              <option value="02">Fevereiro</option>
              <option value="03">Março</option>
              <option value="04">Abril</option>
              <option value="05">Maio</option>
              <option value="06">Junho</option>
              <option value="07">Julho</option>
              <option value="08">Agosto</option>
              <option value="09">Setembro</option>
              <option value="10">Outubro</option>
              <option value="11">Novembro</option>
              <option value="12">Dezembro</option>
            </Select>

            <Select
              className={styles.select}
              label="Ano"
              name="year"
              required
              {...year}
            >
              <option value="">Selecione</option>
              <option value="2021">2021</option>
              <option value="2022">2022</option>
              <option value="2023">2023</option>
              <option value="2024">2024</option>
              <option value="2025">2025</option>
            </Select>
          </div>
          <div className={styles.flex}>
            <Select
              className={styles.select}
              label="Tipo de Usuário"
              name="userType"
              required
              {...userType}
            >
              <option value="">Selecione</option>
              <option value="1">APP</option>
              <option value="2">PDV</option>
            </Select>

            {userType.value === '1' ? (
              <Select
                className={styles.select}
                label="Tipo de Cadastro Social"
                name="cadastroSocial"
                required
                {...cadastroSocial}
              >
                <option value="">Selecione</option>
                <option value="2">CPF</option>
                <option value="3">CNPJ</option>
              </Select>
            ) : (
              <Select
                className={styles.select}
                label="Tipo de Cadastro Social"
                name="cadastroSocial"
                required
                {...cadastroSocial}
              >
                <option value="">Selecione</option>
                <option value="1">CPF e CNPJ</option>
                {/* <option value="2">CPF</option>
                <option value="3">CNPJ</option> */}
              </Select>
            )}
          </div>

          {/* <Input
            className={styles.input}
            label="E-mail"
            type="email"
            name="email"
            placeholder="seu_email@transitarconsultoria.com"
            required
            {...email}
          /> */}
          <div className={styles.wrapper}></div>
          {loading ? (
            <Button disabled>Gerando CSV...</Button>
          ) : (
            <Button>Gerar CSV</Button>
          )}
        </form>
      </section>
    );
  } else {
    return (
      <section className="animeLeft">
        <Head title={userType.value === '1' ? 'Vendas APP' : 'Vendas PDV'} />
        <MUIDataTable
          title={
            userType.value === '1'
              ? `Vendas APP | Total Cads = ${totalCads} | Total Valor NF dos clientes CPF = R$ ${
                  totalCpfConvertido === undefined
                    ? (totalCpfConvertido = 0)
                    : totalCpfConvertido
                }`
              : `Vendas PDV | Total Cads = ${totalCads}`
          }
          data={data}
          columns={columns}
          options={options}
        />
      </section>
    );
  }
};

export default GerarCsv;
